import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { UserNameFullFragmentDoc } from '../../project-comments/graphql/project.comments.query.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchProjectQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type FetchProjectQuery = { __typename?: 'HyperionSchemaQuery', project?: { __typename?: 'Project', id: string, trueId?: string | null, parentId?: number | null, isAta?: number | null, constructionSiteNumber?: string | null, startDate?: string | null, endDate?: string | null, madeBy?: string | null, createdBy?: number | null, mark?: string | null, projectColor?: string | null, mileCost?: number | null, milePrice?: number | null, offerId?: number | null, offertId?: number | null, offertSum?: number | null, offertSumWork?: number | null, orderNumber?: string | null, weekendHourProcent?: number | null, invoicedInOtherSystem?: number | null, socialInsurance?: number | null, trakHalfDayPrice?: number | null, trakDayPrice?: number | null, trakNightPrice?: number | null, privMileCost?: number | null, client?: number | null, status?: number | null, establishment?: number | null, typeId?: number | null, shortMessage?: string | null, availableForTimeReport?: number | null, totalTimeReports?: number | null, totalTimeReportsExtra?: number | null, totalDays?: number | null, totalDaysExtra?: number | null, totalHours?: number | null, totalHoursExtra?: number | null, hoursInvoiced?: number | null, hoursInvoicedExtra?: number | null, hoursNotInvoiced?: number | null, hoursNotInvoicedExtra?: number | null, milesInvoiced?: number | null, milesInvoicedExtra?: number | null, milesNotInvoiced?: number | null, milesNotInvoicedExtra?: number | null, milesPrivate?: number | null, milesPrivateExtra?: number | null, subsistenceDays?: number | null, subsistenceDaysExtra?: number | null, subsistenceHalfDays?: number | null, subsistenceHalfDaysExtra?: number | null, subsistenceNights?: number | null, subsistenceNightsExtra?: number | null, done?: number | null, doneByUserId?: number | null, subProjectCount?: number | null, mainProject?: { __typename?: 'Project', id: string, trueId?: string | null, mark?: string | null } | null, subProjects?: { __typename?: 'ProjectConnection', edges?: Array<{ __typename?: 'ProjectEdge', node?: { __typename?: 'Project', id: string, trueId?: string | null, mark?: string | null } | null } | null> | null } | null, offer?: { __typename?: 'Offer', id: string, trueId?: string | null } | null, establishmentContact?: { __typename?: 'Contact', name?: string | null, orderBuisnessName?: string | null, address?: string | null, address2?: string | null, cityCode?: string | null, city?: string | null, id: string, mail?: string | null, mobilePhone?: string | null, orgNr?: string | null, phone?: string | null, trueId?: string | null, contactType?: string | null } | null, clientContact?: { __typename?: 'Contact', address?: string | null, address2?: string | null, betalningsvillkor?: number | null, cityCode?: string | null, city?: string | null, contactType?: string | null, mail?: string | null, mailInvoice?: string | null, mobilePhone?: string | null, orgNr?: string | null, propertyName?: string | null, housingAssociationOrgNumber?: string | null, apartmentDesignation?: string | null, phone?: string | null, reverseTax?: number | null, trueId?: string | null, hourCost?: number | null, costProcent?: number | null, id: string, name?: string | null, orderBuisnessName?: string | null, parentCrediflow?: { __typename?: 'ContactCrediflowConnection', id: string, isAccepted?: number | null } | null } | null, createdByUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, projectCostTypes?: { __typename?: 'ProjectCostTypeConnection', edges?: Array<{ __typename?: 'ProjectCostTypeEdge', node?: { __typename?: 'ProjectCostType', id: string, name?: string | null, procent?: number | null, products?: { __typename?: 'ProjectproductConnection', edges?: Array<{ __typename?: 'ProjectproductEdge', node?: { __typename?: 'Projectproduct', id: string, date?: string | null, created?: string | null, artnr?: string | null, antal?: number | null, extra?: string | null, totalAmount?: number | null, projectCostTypeId?: number | null, avtalspris?: number | null, avtalsprisCost?: number | null, benamning?: string | null, enhet?: string | null, invoiceId?: number | null, dayId?: number | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, day?: { __typename?: 'Day', id: string, date?: string | null, hours?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, supplierInvoice?: { __typename?: 'Invoice', id: string, invoiceSourceDocuments_PreInvoiceTypeHyperion?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionConnection', edges?: Array<{ __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionEdge', node?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunction', id: string, url?: string | null, label?: string | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | null> | null } | null, externalIds?: { __typename?: 'ProjectExternalIdConnection', edges?: Array<{ __typename?: 'ProjectExternalIdEdge', node?: { __typename?: 'ProjectExternalId', id: string, source?: string | null, sourceId?: string | null, name?: string | null } | null } | null> | null } | null, userCostTypes?: { __typename?: 'ProjectUserCostTypeConnection', edges?: Array<{ __typename?: 'ProjectUserCostTypeEdge', node?: { __typename?: 'ProjectUserCostType', id: string, companyCostTypeId?: number | null, cost?: number | null, internalCost?: number | null } | null } | null> | null } | null, acontoList_PreProjectTypeHyperion?: { __typename?: 'acontoListConnection', edges?: Array<{ __typename?: 'acontoListEdge', node?: { __typename?: 'acontoList', fdatum?: string | null, currency?: string | null, sumBox?: string | null, fakturaNr?: string | null } | null } | null> | null } | null } | null };

export type ProjectExternalIdBaseFragment = { __typename?: 'ProjectExternalId', id: string, source?: string | null, sourceId?: string | null, name?: string | null };

export type ProjectClientContactBaseFragment = { __typename?: 'Contact', id: string, name?: string | null, orderBuisnessName?: string | null, mail?: string | null };

export type ProductFragment = { __typename?: 'Projectproduct', id: string, date?: string | null, created?: string | null, artnr?: string | null, antal?: number | null, extra?: string | null, totalAmount?: number | null, projectCostTypeId?: number | null, avtalspris?: number | null, avtalsprisCost?: number | null, benamning?: string | null, enhet?: string | null, invoiceId?: number | null, dayId?: number | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, day?: { __typename?: 'Day', id: string, date?: string | null, hours?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, supplierInvoice?: { __typename?: 'Invoice', id: string, invoiceSourceDocuments_PreInvoiceTypeHyperion?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionConnection', edges?: Array<{ __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionEdge', node?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunction', id: string, url?: string | null, label?: string | null } | null } | null> | null } | null } | null };

export type ProjectCostTypeFragment = { __typename?: 'ProjectCostType', id: string, name?: string | null, procent?: number | null, products?: { __typename?: 'ProjectproductConnection', edges?: Array<{ __typename?: 'ProjectproductEdge', node?: { __typename?: 'Projectproduct', id: string, date?: string | null, created?: string | null, artnr?: string | null, antal?: number | null, extra?: string | null, totalAmount?: number | null, projectCostTypeId?: number | null, avtalspris?: number | null, avtalsprisCost?: number | null, benamning?: string | null, enhet?: string | null, invoiceId?: number | null, dayId?: number | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, day?: { __typename?: 'Day', id: string, date?: string | null, hours?: number | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, supplierInvoice?: { __typename?: 'Invoice', id: string, invoiceSourceDocuments_PreInvoiceTypeHyperion?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionConnection', edges?: Array<{ __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionEdge', node?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunction', id: string, url?: string | null, label?: string | null } | null } | null> | null } | null } | null } | null } | null> | null } | null };

export type SubProjectFragment = { __typename?: 'Project', id: string, trueId?: string | null, mark?: string | null };

export type UpdateShortMessageMutationVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
  shortMessage?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateShortMessageMutation = { __typename?: 'HyperionSchemaMutation', projectTypeHyperionMutation?: { __typename?: 'Project', id: string, shortMessage?: string | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', errors?: Array<string | null> | null } | null> | null } | null };

export type UpdateAllowReportingMutationVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
  allowReporting?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type UpdateAllowReportingMutation = { __typename?: 'HyperionSchemaMutation', projectTypeHyperionMutation?: { __typename?: 'Project', id: string, availableForTimeReport?: number | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', mutationSucceeded?: boolean | null, msg?: string | null, errors?: Array<string | null> | null } | null> | null } | null };

export type UpdateProjectDoneStateMutationVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
  done?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type UpdateProjectDoneStateMutation = { __typename?: 'HyperionSchemaMutation', projectTypeHyperionMutation?: { __typename?: 'Project', id: string, done?: number | null, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', mutationSucceeded?: boolean | null, msg?: string | null, errors?: Array<string | null> | null } | null> | null } | null };

export type UpdateProjectPricesFromClientMutationVariables = Types.Exact<{
  contactId?: Types.InputMaybe<Types.Scalars['Int']>;
  projectId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type UpdateProjectPricesFromClientMutation = { __typename?: 'HyperionSchemaMutation', updateProjectPricesFromClientMutation?: { __typename?: 'Contact', id: string, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', mutationSucceeded?: boolean | null, msg?: string | null, errors?: Array<string | null> | null } | null> | null } | null };

export const ProjectExternalIdBaseFragmentDoc = gql`
    fragment ProjectExternalIdBase on ProjectExternalId {
  id
  source
  sourceId
  name
}
    `;
export const ProjectClientContactBaseFragmentDoc = gql`
    fragment ProjectClientContactBase on Contact {
  id
  name
  orderBuisnessName
  mail
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Projectproduct {
  user {
    firstName
    lastName
  }
  id
  date
  created
  artnr
  antal
  extra
  totalAmount
  projectCostTypeId
  avtalspris
  avtalsprisCost
  benamning
  enhet
  invoiceId
  dayId
  day {
    id
    date
    hours
    user {
      id
      firstName
      lastName
    }
  }
  supplierInvoice {
    id
    invoiceSourceDocuments_PreInvoiceTypeHyperion {
      edges {
        node {
          id
          url
          label
        }
      }
    }
  }
}
    `;
export const ProjectCostTypeFragmentDoc = gql`
    fragment ProjectCostType on ProjectCostType {
  id
  name
  procent
  products {
    edges {
      node {
        ...Product
      }
    }
  }
}
    ${ProductFragmentDoc}`;
export const SubProjectFragmentDoc = gql`
    fragment subProject on Project {
  id
  trueId
  mark
}
    `;
export const FetchProjectDocument = gql`
    query fetchProject($id: Int) {
  project(id: $id) {
    id
    trueId
    parentId
    isAta
    constructionSiteNumber
    startDate
    endDate
    madeBy
    createdBy
    mark
    projectColor
    mileCost
    milePrice
    offerId
    offertId
    offertSum
    offertSumWork
    orderNumber
    weekendHourProcent
    invoicedInOtherSystem
    socialInsurance
    trakHalfDayPrice
    trakDayPrice
    trakNightPrice
    privMileCost
    client
    status
    establishment
    typeId
    shortMessage
    availableForTimeReport
    totalTimeReports
    totalTimeReportsExtra
    totalDays
    totalDaysExtra
    totalHours
    totalHoursExtra
    hoursInvoiced
    hoursInvoicedExtra
    hoursNotInvoiced
    hoursNotInvoicedExtra
    milesInvoiced
    milesInvoicedExtra
    milesNotInvoiced
    milesNotInvoicedExtra
    milesPrivate
    milesPrivateExtra
    subsistenceDays
    subsistenceDaysExtra
    subsistenceHalfDays
    subsistenceHalfDaysExtra
    subsistenceNights
    subsistenceNightsExtra
    done
    doneByUserId
    subProjectCount
    mainProject {
      ...subProject
    }
    subProjects(status: [0, 1, 2, 3]) {
      edges {
        node {
          ...subProject
        }
      }
    }
    offer {
      id
      trueId
    }
    establishmentContact {
      name
      orderBuisnessName
      address
      address2
      cityCode
      city
      id
      mail
      mobilePhone
      orgNr
      phone
      trueId
      contactType
      orgNr
    }
    clientContact {
      ...ProjectClientContactBase
      address
      address2
      betalningsvillkor
      cityCode
      city
      contactType
      mail
      mailInvoice
      mobilePhone
      orgNr
      propertyName
      housingAssociationOrgNumber
      apartmentDesignation
      phone
      reverseTax
      trueId
      hourCost
      costProcent
      parentCrediflow {
        id
        isAccepted
      }
    }
    createdByUser {
      ...UserNameFull
    }
    projectCostTypes {
      edges {
        node {
          ...ProjectCostType
        }
      }
    }
    externalIds {
      edges {
        node {
          ...ProjectExternalIdBase
        }
      }
    }
    userCostTypes {
      edges {
        node {
          id
          companyCostTypeId
          cost
          internalCost
        }
      }
    }
    acontoList_PreProjectTypeHyperion {
      edges {
        node {
          fdatum
          currency
          sumBox
          fakturaNr
        }
      }
    }
  }
}
    ${SubProjectFragmentDoc}
${ProjectClientContactBaseFragmentDoc}
${UserNameFullFragmentDoc}
${ProjectCostTypeFragmentDoc}
${ProjectExternalIdBaseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchProjectGQL extends Apollo.Query<FetchProjectQuery, FetchProjectQueryVariables> {
    document = FetchProjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShortMessageDocument = gql`
    mutation updateShortMessage($projectId: Int, $shortMessage: String) {
  projectTypeHyperionMutation(
    updateProject: {id: $projectId, shortMessage: $shortMessage}
  ) {
    id
    shortMessage
    mutationDetails {
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShortMessageGQL extends Apollo.Mutation<UpdateShortMessageMutation, UpdateShortMessageMutationVariables> {
    document = UpdateShortMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAllowReportingDocument = gql`
    mutation updateAllowReporting($projectId: Int, $allowReporting: Int) {
  projectTypeHyperionMutation(
    updateProject: {id: $projectId, availableForTimeReport: $allowReporting}
  ) {
    id
    availableForTimeReport
    mutationDetails {
      mutationSucceeded
      msg
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAllowReportingGQL extends Apollo.Mutation<UpdateAllowReportingMutation, UpdateAllowReportingMutationVariables> {
    document = UpdateAllowReportingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProjectDoneStateDocument = gql`
    mutation updateProjectDoneState($projectId: Int, $done: Int) {
  projectTypeHyperionMutation(updateProject: {id: $projectId, done: $done}) {
    id
    done
    mutationDetails {
      mutationSucceeded
      msg
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProjectDoneStateGQL extends Apollo.Mutation<UpdateProjectDoneStateMutation, UpdateProjectDoneStateMutationVariables> {
    document = UpdateProjectDoneStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProjectPricesFromClientDocument = gql`
    mutation updateProjectPricesFromClient($contactId: Int, $projectId: Int) {
  updateProjectPricesFromClientMutation(
    contactId: $contactId
    projectId: $projectId
  ) {
    id
    mutationDetails {
      mutationSucceeded
      msg
      errors
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProjectPricesFromClientGQL extends Apollo.Mutation<UpdateProjectPricesFromClientMutation, UpdateProjectPricesFromClientMutationVariables> {
    document = UpdateProjectPricesFromClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }